/* eslint-disable max-len */
import React, { memo, useRef, useEffect } from 'react';
import * as echarts from 'echarts/lib/echarts';
import { createOptions } from './utils';
import { useAtomValue } from 'jotai';
import { draggingAtom } from '../../utils';

function Chart(props) {
  const isDragging = useAtomValue(draggingAtom);
  const {
    cellData,
    appliedColors,
    maxMetricValue,
    dimensionName,
    filters,
    unit,
    shouldCalculatePercentage,
  } = props;
  const myChart = useRef(null);

  useEffect(() => {
    const chart = echarts.init(myChart.current);
    // resize to adjust length based on value change (unit toggle)
    chart.resize();

    let max = maxMetricValue;
    if (unit === '%' && shouldCalculatePercentage) {
      max = 100;
    }
    const chartOption = createOptions(cellData, appliedColors, max, dimensionName, filters, unit);
    /** Will cause error when show tooltip during dragging */
    if (isDragging) {
      chartOption.tooltip.show = false;
    }
    chart.setOption(chartOption, { notMerge: true });
  }, [
    cellData,
    appliedColors,
    maxMetricValue,
    dimensionName,
    filters,
    shouldCalculatePercentage,
    unit,
    isDragging,
  ]);

  return (
    <div
      ref={myChart}
      style={{
        width: '100%',
        height: '100px',
        overflow: 'visible',
      }}
    />
  );
}

export default memo(Chart);
